import { Boxes } from "lucide-react";

export function PlaceholderPage({ eyebrow, title, copy }: { eyebrow: string; title: string; copy: string }) {
  return <div className="brands-page placeholder-page">
    <header className="library-heading"><div><span className="eyebrow">{eyebrow}</span><h1>{title}</h1></div></header>
    <div className="empty-state compact"><Boxes aria-hidden="true" /><h2>{title} are coming next</h2><p>{copy}</p></div>
  </div>;
}
